module.exports = __webpack_public_path__ + "img/building-4.b9b270e6.svg";